import { AdvisorConfigKeyFE_SmartDocs_NoteIds, ModuleFE_Advisor_Facility, SessionKey_FacilityId } from '@app/advisor-frontend';
/**
 * Retrieves the note template id based on the facility or falls back to the config.
 * @returns The note template id or undefined if not available.
 */
export const getNoteTemplateId = () => {
    const facilityId = SessionKey_FacilityId.get();
    if (!facilityId)
        return;
    const facility = ModuleFE_Advisor_Facility.cache.unique(facilityId);
    return facility?.noteTemplateId ?? AdvisorConfigKeyFE_SmartDocs_NoteIds.get()?.summary;
};
//# sourceMappingURL=get-note-template-id.js.map